import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { titles } from '../../../../styles/colors';

const { colors, common, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm + spacing.xs,
	},
	fieldLabel: {
		color: titles,
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.bold,
		marginBottom: spacing.xs,
	},
	fieldContainer: {
		display: 'flex',
		flexDirection: 'column',
	},
	input: {
		border: common.border,
		borderRadius: common.borderRadius,
		fontSize: typography.fontSizes.sm,
		padding: `${spacing.sm}px ${spacing.sm + spacing.xs}px`,
		width: '100%',
		boxSizing: 'border-box',
		':focus': {
			borderColor: colors.primary.main,
			outline: 'none',
		},
	},
});
